@if (!isMobileView) {
  <div class="card card-according">
    <div role="button" (click)="collapseAccordion()">
      <div class="card-header" [ngClass]="{ collapsed: isCollapsed }">
        <ng-container
          *ngTemplateOutlet="headerTemplate ?? defaultHeaderTemplate"
        ></ng-container>
      </div>
    </div>

    <div class="collapse-accordion" ngbAccordion #accordion="ngbAccordion">
      <div ngbAccordionItem="first">
        <div id="collapseExample" ngbAccordionCollapse>
          <div class="accordion-content-container">
            <ng-container
              *ngTemplateOutlet="contentTemplate ?? null"
            ></ng-container>
            <ng-container
              *ngComponentOutlet="contentComponent ?? null"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (isMobileView) {
  <div class="mobile-button-container" [class.show]="showMobileButton">
    <button
      class="btn btn-outline-primary w-100 mb-3 d-flex align-items-center justify-content-between rounded-3 mobile-toggle-btn"
      (click)="collapseAccordion()"
      type="button"
    >
      <span class="d-flex align-items-center">
        <i class="fa fa-filter me-2"></i>
        {{ title | translate }}
      </span>
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>

  <div
    class="position-fixed bg-primary text-white d-flex align-items-center justify-content-center floating-filter-icon"
    [class.show]="!showOffcanvas"
    [class.dragging]="isDragging"
    (mousedown)="onFloatingIconMouseDown($event)"
    (touchstart)="onFloatingIconTouchStart($event)"
    [attr.aria-label]="title + ' floating button'"
    [style.top.%]="floatingIconPosition"
  >
    <i class="fa fa-filter"></i>
  </div>

  <div
    class="offcanvas-lg offcanvas-end border-0 card mobile-filter-offcanvas rounded-0 pb-0"
    [class.show]="showOffcanvas"
    [style.visibility]="showOffcanvas ? 'visible' : 'hidden'"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="offcanvas-header text-dark card-header border-0 d-flex align-items-center justify-content-between pt-0 pb-0"
    >
      <div class="flex-grow-1">
        <ng-container
          *ngTemplateOutlet="headerTemplate ?? defaultOffcanvasHeaderTemplate"
        ></ng-container>
      </div>
      <button
        type="button"
        class="btn-close opacity-75 text-dark"
        aria-label="Close"
        (click)="closeOffcanvas()"
      ></button>
    </div>

    <div class="offcanvas-body border-0 flex-grow-1 p-0 m-0">
      <div class="offcanvas-content-container h-100">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        <ng-container #dynamicComponentContainer></ng-container>
      </div>
    </div>
  </div>

  @if (showOffcanvas) {
    <div
      class="offcanvas-backdrop"
      [class.show]="showOffcanvas"
      (click)="onBackdropClick($event)"
    ></div>
  }
}

<ng-template #defaultHeaderTemplate>
  <div class="d-flex justify-content-between align-items-center">
    <h5>{{ title | translate }}</h5>
    <i
      class="fa"
      [ngClass]="{
        'fa-chevron-up': !isCollapsed,
        'fa-chevron-down': isCollapsed,
      }"
    ></i>
  </div>
</ng-template>

<ng-template #defaultOffcanvasHeaderTemplate>
  <h5 class="offcanvas-title">{{ title | translate }}</h5>
</ng-template>
